import { isExperimentFlagEnabled } from './useExperimentFlag';

export const isQuickFilterAutoEnabled = () => isExperimentFlagEnabled('enable_quick_filter_auto', 'exp');

export const useExperimentQuickFilterAuto = isQuickFilterAutoEnabled;
